'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import type { VaultV1Migration } from '@/lib/procedures/vaultV1Migration.contract';
import { useTrackV1ToV2MigrationEntryViewed } from '@/lib/analytics/client/hooks/useTrackV1ToV2MigrationEntryViewed';
import { useOpenMigrationModal } from './hooks/useOpenMigrationModal';
interface UpgradeButtonProps {
  migrationTarget: VaultV1Migration;
  fullWidth?: boolean;
}
const UpgradeButton = t0 => {
  const $ = _c(9);
  const {
    migrationTarget,
    fullWidth
  } = t0;
  useTrackV1ToV2MigrationEntryViewed("dashboard_button", migrationTarget);
  const openMigrationModal = useOpenMigrationModal(migrationTarget, "dashboard_button");
  let t1;
  if ($[0] !== openMigrationModal) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      openMigrationModal();
    };
    $[0] = openMigrationModal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  if (fullWidth) {
    let t2;
    if ($[2] !== handleClick) {
      t2 = <Button onClick={handleClick} className="w-full">Upgrade</Button>;
      $[2] = handleClick;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== handleClick) {
    t2 = <TooltipTrigger asChild={true}><Button size="sm" onClick={handleClick}>Upgrade</Button></TooltipTrigger>;
    $[4] = handleClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TooltipContent>Upgrade to Morpho V2 vault</TooltipContent>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <Tooltip>{t2}{t3}</Tooltip>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default UpgradeButton;